module.exports = __webpack_public_path__ + "static/media/cream.b9902ec4.svg";